import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { type IGatsbyImageData } from 'gatsby-plugin-image';
import { Image } from './Image';

type Node = {
  relativePath: string;
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData;
  };
};

type Props = { path: string; alt?: string };

export const SupportImage: React.FC<Props> = ({ path, alt = 'screenshot' }) => {
  const { allFile } = useStaticQuery<{ allFile: { nodes: Node[] } }>(graphql`
    {
      allFile(filter: { relativePath: { glob: "support/**/*.png" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    }
  `);
  const node = allFile.nodes.find((n) => n.relativePath === path);
  if (!node) return null;
  return <Image image={node.childImageSharp.gatsbyImageData} alt={alt} />;
};
